/* eslint-disable import/no-named-as-default */
import React from 'react'
import { string } from 'prop-types'
import Logo from '../asda-com/Logo'
import HamburgerMenu from '../asda-com/HamburgerMenu'
import TopNav from './TopNav'
import './header.scss'

const Header = ({ homeUrl }) => (
  <div className="header-wrapper">
    <HamburgerMenu />
    <Logo homeUrl={homeUrl} />
    <TopNav />
  </div>
)

Header.propTypes = {
  homeUrl: string,
}

Header.defaultProps = {
  homeUrl: '/baby-club',
}

export default Header



// WEBPACK FOOTER //
// ./components/header/baby-club/index.js